export const query_audit = `
query getAudit($tenantId: String!) {
  audit(where: { TenantId: {_eq: $tenantId}}, order_by: {OperationDate: desc}) {
    Id
    TenantId
    UserId
    AziendaId
    Area
    Operation
    OperationDate
    EntityType
    EntityId
    OldValues
    NewValues
    user {
      Name
      Surname
    }
  }
}`;
